import React from 'react';
import { Link } from '@reach/router';
import styled from 'styled-components';

const Thumb = styled.div`
  margin: 0 auto 10px;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;

  @media (min-width: 767px) {
    margin-bottom: 0;
    padding: 5px;
    width: 50%;
    float: left;
  }
  @media (min-width: 992px) {
    width: 33.333333333%;
  }
  @media (min-width: 1200px) {
    width: 25%;
`;

const ThumbImage = styled.img`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  display: block;
  transition: 0.5s ease-out;

  ${Thumb}:hover & {
    transform: scale(1.25);
  }
`;

const ThumbOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  max-width: 400px;
  width: 100%;
  height: 100%;
  padding: 5px;
  background-color: rgba(255, 255, 255, 0.9);
  opacity: 0;
  transition: 0.5s ease-out;
  box-sizing: border-box;

  ${Thumb}:hover & {
    opacity: 1;
  }
`;

const ThumbText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  text-align: center;
  color: #428bca;
  font: 700 14px/14px 'Lato', sans-serif;
  text-transform: uppercase;
`;

const ThumbContainer = styled.div`
  position: relative;
  border: 1px solid #cbcbc3;
  overflow: hidden;
`;

function Thumbnail({ client, friendlyName, image }) {
  return (
    <Thumb data-testid="thumbnail">
      <Link to={`project/${friendlyName}`} data-testid="friendlyName">
        <ThumbContainer>
          <ThumbImage data-testid="image" alt={client} src={image} />
          <ThumbOverlay data-testid="client">
            <ThumbText>{client}</ThumbText>
          </ThumbOverlay>
        </ThumbContainer>
      </Link>
    </Thumb>
  );
}

export default Thumbnail;
